// @ts-nocheck
import buttonSizeVariants from "@insite/mobius/Button/buttonSizeVariants";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";

/** buttonSizeVariants
 * ------------------------------------------------------------------------------------------
 * height: Height applied as "min-height" (px)
 * fontSize: Font size (px)
 * padding: CSS applied to the padding property "padding: [VALUE];"
 * icon: Icon size (px)
 * iconPadding: Spacing between the icon and the text (px)
 */

Object.assign(buttonSizeVariants, {
    small: {
        height: 32, // Store Custom Code
        fontSize: 14, // Store Custom Code
        icon: 20,
        iconPadding: 23, // Store Custom Code
    },
    medium: {
        fontSize: 16, // Store Custom Code
        icon: 24,
        iconPadding: 28, // Store Custom Code
    },
    large: {
        icon: 28, // Store Custom Code
        iconPadding: 32, // Store Custom Code
    },
});
